// ============================================================================
// Regular Expression Patterns
// ============================================================================

/**
 * Regex pattern for validating uppercase letters
 */
export const UPPERCASE_REGEX = /[A-Z]/;

/**
 * Regex pattern for validating special characters
 * Includes: !@#$%^&*(),.?":{}|<>
 */
export const SPECIAL_CHAR_REGEX = /[!@#$%^&*(),.?":{}|<>]/;

/**
 * Regex pattern for validating that a string contains only digits
 */
export const DIGITS_ONLY_REGEX = /^\d+$/;

/**
 * Regex pattern for validating that a string contains only letters and spaces
 * Used for name fields where at least one character is required
 */
export const LETTERS_ONLY_REGEX = /^[A-Za-z\s]+$/;

/**
 * Regex pattern for validating that a string contains only letters and spaces
 * Allows empty strings (for optional fields)
 */
export const LETTERS_ONLY_OPTIONAL_REGEX = /^[A-Za-z\s]*$/;
export const passwordConfig = {
  /**
   * Regex pattern for uppercase letters
   */
  uppercaseRegex: /[A-Z]/,

  /**
   * Regex pattern for special characters
   */
  specialCharRegex: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
} as const;
